<section class="container mx-auto w-full h-full bg-white md:px-10 md:py-16 px-4 py-8">
  <div class="flex flex-col justify-evenly gap-14 md:gap-0 items-center h-full w-full">
    <div class="flex flex-col lg:flex-row justify-between items-center gap-4 w-full md:mt-14">
      <div class="max-w-60 flex flex-col items-center justify-center gap-4 md:gap-8 md:mb-0 mb-5">
        <div class="w-full h-full">
          <img
            src="organizer/flow/flow1.png"
            alt="Organizer Flow 1"
            class="w-full h-full object-cover"
          />
        </div>
        <div class="flex items-center justify-center gap-2">
          <p
            i18n="organizer.flow|Create sessions step@@organizer.flow.step1"
            class="text-black md:text-base text-smfont-medium"
          >
            Create sessions
          </p>
        </div>
      </div>

      <div class="max-w-60 flex flex-col items-center justify-center gap-4 md:gap-8 md:mb-0 mb-5">
        <div class="w-full h-full">
          <img
            src="organizer/flow/flow2.png"
            alt="Organizer Flow 2"
            class="w-full h-full object-cover"
          />
        </div>
        <div class="flex items-center justify-center gap-2">
          <p
            i18n="organizer.flow|Let players book step@@organizer.flow.step2"
            class="text-black md:text-base text-sm font-medium"
          >
            Let players book
          </p>
        </div>
      </div>

      <div class="max-w-60 flex flex-col items-center justify-center gap-4 md:gap-8">
        <div class="w-full h-full">
          <img
            src="organizer/flow/flow3.png"
            alt="Organizer Flow 3"
            class="w-full h-full object-cover"
          />
        </div>
        <div class="flex items-center justify-center gap-2">
          <p
            i18n="organizer.flow|Get paid in advance step@@organizer.flow.step3"
            class="text-black md:text-base text-sm font-medium"
          >
            And get paid in advance
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
